export default __webpack_public_path__ + "static/5_15-67262b41d1a121ae8394c1bc30a6b0b8.png";